import { get, prefix } from '../index';
import { getDomainBaseUrl } from '@ugc-utils/domains';

const getActionPermissions = (pid, { action = [], languageCode = '' }) => {
  const params = new URLSearchParams();
  if (action.length) {
    action.forEach(item => params.append('action', item));
  }
  params.append('languageCode', languageCode);
  return get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${pid}/permissions`, params);
};

export { getActionPermissions };
